import { Component, ElementRef, Inject, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { MatDialog } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';import { SharedService } from '../../../shared/services/shared.service';
import { FinanciacionPrivadaModel } from './financiacion-privada.model';
import { FinanciacionPrivadaFormComponent } from './financiacion-privada-form.component';


@Component({
    selector: 'convfact-dialog-import-account-financiacion-privada',
    templateUrl: './financiacion-privada-dialog-importAccount.component.html',
    styleUrls: ['./financiacion-privada.component.css'],
    standalone: false
})
export class FinanciacionPrivadaDialogImportAccount {

    dataImport: FinanciacionPrivadaModel = this.data.dataImport;

    constructor(
        public dialogRef: MatDialogRef<FinanciacionPrivadaFormComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        public snackBar: MatSnackBar,
        public sharedService: SharedService
    ) { }

    startImport() {
        this.sharedService.importAccountsUpdate(this.dataImport, "FinanciacionPrivada").then(result => {
            this.dialogRef.close();
        });
    }

    closeDialog() {
        this.dialogRef.close();
    }




}
